user-fields =
  { $field ->
    *[x_unknown] [{$field}]
    [created_at] Erstellt am
    [last_access] Letzte Anmeldung
    [profile_visibility] Daten-Sichtbarkeit
    [password] Passwort
    [current_password] Aktuelles Passwort
    [new_password] Neues Passwort
    [new_password_repeated] Neues Passwort wiederholen
    [email] E-Mail-Adresse
    [given_name] Vorname
    [family_name] Nachname
    [display_name] Anzeigename
    [avatar] Profilbild
    [employment_type] Mitarbeiter:innen-Status
    [role] System-Rolle
    [status] System-Status
    [hash] Hash
    [terms] Allgemeine Geschäfts-Bedingungen
    [users] Benutzer:innen
    [affiliation] Zugehörigkeit
  }

user-fields-placeholders =
  { $field ->
    *[x_unknown] [{$field}]
    [users] Vorname oder Nachname suchen
  }

user-general-fields =
  { $field ->
    *[x_unknown] [{$field}]
    [languages] Sprachen
    [phone_business] Telefon (dienstlich)
    [fax] Fax
    [skills] Skill
    [qualifications] Qualifikationen
    [project_team] Projekt (Team)
    [extra_infos] Zusätzliche Aufgaben
  }

user-personal-fields =
  { $field ->
    *[x_unknown] [{$field}]
    [date_of_birth] Geburtsdatum
    [gender] Geschlecht
    [profession] Beruf
    [denomination] Konfession
  }

user-contact-fields =
  { $field ->
    *[x_unknown] [{$field}]
    [phone_private] Telefon (privat)
    [phone_mobile] Telefon (mobil)
    [address] Wohnadresse
    [address_line_1] Straße & Hausnummer
    [address_line_2] Adresszusatz
    [postal_code] Postleitzahl
    [city] Ort
  }
user-financial-fields =
  { $field ->
    *[x_unknown] [{$field}]
    [name] Kontoinhaber:in
    [bic] BIC
    [iban] IBAN
  }

user-notifications-fields =
  { $field ->
    *[x_unknown] [{$field}]
    [channel] Benachrichtigungs-Kanäle
  }

user-absence-note-enabled =
  { $enabled ->
    *[x_unknown] [{$enabled}]
    [true] Abwesenheitsnotiz aktiviert
    [false] Abwesenheitsnotiz deaktiviert
  }
user-absence-note-fields =
  { $field ->
    *[x_unknown] [{$field}]
    [enabled] Status
    [subject] Betreff
    [message] Nachricht
  }

user-employee-fields =
  { $field ->
    *[x_unknown] [{$field}]
    [notes] Notizen
    [personnel_number] Personalnummer
    [entrance_date] Eintrittsdatum
    [leave_date] Austrittsdatum
    [absence_leaves] Beurlaubungen
    [absence_leaves_value] Von-Datum
    [absence_leaves_end_value] Bis-Datum
    [absence_leave] Beurlaubung {$number}
  }

user-list =
  { $field ->
    *[x_unknown] [{$field}]
    [actions] Aktion
  }

user-list-document-title = Benutzer:innen
user-list-breadcrumb = Benutzer:innen
user-list-page-title = Benutzer:innen
user-list-show-actions = Aktionen anzeigen
user-list-to-profile = Zum Profil
user-list-to-settings = Profil bearbeiten
user-list-last-access-na = Keine Anmeldung

user-list-filter-placeholders =
  { $field ->
    *[x_unknown] [{$field}]
    [display_name] Anzeigename suchen
    [given_name] Vorname suchen
    [family_name] Nachname suchen
    [role] Rolle wählen
    [system_role] System-Rolle wählen
    [system_status] System-Status wählen
    [training_role] Ausbildungsstatus wählen
    [employment_type] Mitarbeiter:innen-Status wählen
    [affiliation] Zugehörigkeit wählen
  }
user-list-filter-login-lock = Gesperrt
user-list-additional-actions = Weitere Aktionen

user-create = Neue:n Benutzer:in erstellen
user-create-document-title = Neue:n Benutzer:in erstellen
user-create-breadcrumb = Neue:n Benutzer:in erstellen
user-create-page-title = Neue:n Benutzer:in erstellen
user-create-success = Benutzer:in wurde erstellt.
user-create-error = Leider konnte der Benutzer nicht erstellt werden (Informationen konnten nicht von Personio abgerufen werden).

user-create-extra = Nach Erstellung des Benutzer:innen-Accounts erhält diese:r einen Freischaltungs-Link per E-Mail mit der sich die:der Benutzer:in anmelden kann.
user-create-submit-button = Benutzer:in erstellen

user-post-create-heading = Lade {$display_name} in dein Netzwerk ein
user-post-create-message = Füge {$display_name} zu deiner Dienststelle oder einer allgemeinen Gruppe hinzu.

user-profile-nav-aria-label = Benutzer:innen-Profil

user-profile-detail-document-title = {$display_name}
user-profile-detail-page-title = Profil von {$display_name}

user-settings-nav-heading = Profil-Einstellungen
user-settings-nav-items =
  { $code ->
    *[x_unknown] [{$code}]
    [account] Account
    [user_preferences] Benutzer:innen-Präferenzen
    [notifications] Benachrichtigungen
    [memberships] Mitgliedschaften
    [employee_data] Mitarbeiter:innen-Daten
  }

user-settings-account-document-title = Account
user-settings-account-breadcrumb = Account
user-settings-account-page-title = Account {$display_name}

user-settings-profile-heading = Profil
user-settings-basic-heading = Account-Zugang
user-settings-general-heading = Allgemeine Benutzer:innen-Daten
user-settings-general-edit = Allgemeine Benutzer:innen-Daten bearbeiten
user-settings-personal-heading = Persönliche Daten
user-settings-personal-edit = Persönliche Daten bearbeiten
user-settings-contact-heading = Kontakt-Daten
user-settings-contact-edit = Kontakt-Daten bearbeiten
user-settings-financial-heading = Konto-Daten zu Abrechnungszwecken
user-settings-financial-edit = Konto-Daten bearbeiten
user-settings-account-heading = Account-Details
user-settings-account-edit = Account-Details bearbeiten
user-settings-delete-heading = Account löschen
user-settings-login-lock-heading = Anmeldesperre

user-settings-personio-sync = Update Datensatz aus Personio
user-settings-account-update-success = Die Kontodaten wurde aktualisiert.
user-settings-account-update-error = Leider hat ein Fehler die Aktualisierung der Kontodaten verhindert.

user-settings-avatar-edit = Profilfoto aktualisieren
user-settings-avatar-edit-document-title = Profilbild
user-settings-avatar-edit-breadcrumb = Profilbild
user-settings-avatar-edit-page-title = Profilbild aktualisieren
user-settings-avatar-edit-success = Das Profilbild wurde aktualisiert.
user-settings-avatar-delete-success = Das Profilbild wurde gelöscht.

user-settings-display-name-edit = Anzeigename bearbeiten
user-settings-display-name-edit-document-title = Anzeigename
user-settings-display-name-edit-breadcrumb = Anzeigename
user-settings-display-name-edit-page-title = Anzeigename bearbeiten
user-settings-display-name-edit-success = Der Anzeigename wurde aktualisiert.

user-settings-email-edit = Account-Zugang bearbeiten
user-settings-email-edit-document-title = Account-Zugang bearbeiten
user-settings-email-edit-breadcrumb = Account-Zugang
user-settings-email-edit-page-title = Account-Zugang bearbeiten
user-settings-email-edit-success = Deine E-Mail-Adresse wurde aktualisiert.

user-settings-password-edit = Passwort bearbeiten
user-settings-password-edit-document-title = Passwort
user-settings-password-edit-breadcrumb = Passwort
user-settings-password-edit-page-title = Passwort bearbeiten
user-settings-password-edit-success = Dein Passwort wurde aktualisiert.

user-settings-general-edit-document-title = Allgemeine Benutzer:innen-Daten
user-settings-general-edit-breadcrumb = Allgemeine Benutzer:innen-Daten
user-settings-general-edit-page-title = Allgemeine Benutzer:innen-Daten bearbeiten
user-settings-general-edit-success = Deine allgemeinen Benutzer:innen-Daten wurden aktualisiert.

user-settings-personal-edit-document-title = Persönliche Daten
user-settings-personal-edit-breadcrumb = Persönliche Daten
user-settings-personal-edit-page-title = Persönliche Daten bearbeiten
user-settings-personal-edit-success = Deine persönlichen Daten wurden aktualisiert.

user-settings-contact-edit-document-title = Kontakt-Daten
user-settings-contact-edit-breadcrumb = Kontakt-Daten
user-settings-contact-edit-page-title = Kontakt-Daten bearbeiten
user-settings-contact-edit-success = Deine Kontakt-Daten wurden aktualisiert.

user-settings-financial-edit-document-title = Konto-Daten
user-settings-financial-edit-breadcrumb = Konto-Daten
user-settings-financial-edit-page-title = Konto-Daten bearbeiten
user-settings-financial-edit-success = Deine Konto-Daten wurden aktualisiert.

user-settings-account-edit-document-title = Account-Details
user-settings-account-edit-breadcrumb = Account-Details
user-settings-account-edit-page-title = Account-Details bearbeiten
user-settings-account-edit-success = Deine Account-Daten wurden aktualisiert.

user-settings-employee-edit-document-title = Mitarbeiter:innen-Daten
user-settings-employee-edit-breadcrumb = Mitarbeiter:innen-Daten
user-settings-employee-edit-page-title = Mitarbeiter:innen-Daten bearbeiten
user-settings-employee-edit-success = Die Mitarbeiter:innen-Daten wurde aktualisiert.

user-settings-preferences-document-title = Benutzer:innen-Präferenzen
user-settings-preferences-breadcrumb = Benutzer:innen-Präferenzen
user-settings-preferences-page-title = Benutzer:innen-Präferenzen {$display_name}

user-settings-notifications-document-title = Benachrichtigungen
user-settings-notifications-breadcrumb = Benachrichtigungen
user-settings-notifications-page-title = Benachrichtigungen
user-settings-notifications-edit-success = Deine Benachrichtigungs-Kanäle wurden aktualisiert.
user-settings-notifications-channel-section-title = Benachrichtigungs-Kanäle

user-settings-memberships-document-title = Mitgliedschaften
user-settings-memberships-breadcrumb = Mitgliedschaften
user-settings-memberships-page-title = Mitgliedschaften

user-settings-absence-note-section-title = Abwesenheitsnotiz für das persönliche Postfach
user-settings-absence-note-message = Sendet eine automatische Antwort auf eingehende Nachrichten im persönlichen Postfach. Das umfasst nicht die Ratsuchenden-Eingänge in der Mail-Beratung.
user-settings-absence-note-edit-success = Abwesenheitsnotiz wurde aktualisiert

user-settings-notifications-mail-section-title = Abwesenheitsnotiz für Mail-Beratung
user-settings-notifications-mail-link = Abwesenheit verwalten

user-settings-affiliation-select = 
  { $orga ->
    *[upd] Stiftung UPD
    [cooperation_partner] Kooperation
  }

user-logout-message = Abmelden …
user-back-to-account-settings = Zurück zu Profil-Einstellungen
user-display-name-extra = Erscheint für jeden sichtbar als Mitgliedsname.
user-global-role = Rolle
user-global-affiliation = Zugehörigkeit
user-absence-leave-range = { DATETIME($start_date, month: "numeric", year: "numeric", day: "numeric") } bis { DATETIME($end_date, month: "numeric", year: "numeric", day: "numeric") }
user-on-leave = Beurlaubt
user-compose-message = Nachricht schreiben
user-edit-profile = Profil bearbeiten
user-email-extra = Eine gültige E-Mail-Adresse. Alle E-Mails der Webseite werden an diese Adresse geschickt. Die Adresse wird nicht veröffentlicht und wird nur verwendet, wenn du ein neues Passwort anforderst oder wenn du einstellst, bestimmte Informationen oder Benachrichtigungen per E-Mail zu erhalten.
user-office-channels = Beratungs-Kanäle
user-office-groups = Interne Gruppen
user-no-memberships = Bisher noch keine Mitgliedschaften.
user-group-role =
  { $role ->
    *[member] Mitglied
    [manager] Gruppen-Manager:in
    [admin] Gruppen-Admin
  }
user-notifications-channel-select =
  { $channel ->
    *[none] Keine Benachrichtigungen an hinterlegte E-Mail-Adresse senden
    [email] E-Mail-Benachrichtigungen zu neuen Nachrichten im persönlichen Postfach aktivieren
  }

user-employee-absence-leaves-from = von
user-employee-absence-leaves-to = bis
user-employee-remove-absence-leave = Entfernen
user-employee-add-absence-leave = Beurlaubung hinzufügen

user-settings-avatar-extra = Wenn du ein Profilbild hinzufügst, können andere Benutzer:innen dich erkennen. Du unterstützt somit die Vernetzung und Kommunikation innerhalb der { -app-name }-Platform.
user-settings-avatar-help-text = Die Datei darf nicht größer als {$max_size_in_megabyte} MB sein. Zulässige Dateiformate sind JPEG, HEIF, PNG und WebP.
user-settings-display-name-extra = Erlaubt dir einen Anzeigenamen zu definieren, der anstelle deines Vor- und Nachnamen auf dieser Platform erscheint. Deine Gruppen-Admin und Verwaltungskräfte können deinen Klarnamen weiterhin einsehen.
user-account-profile-visibility-display-select =
  { $profile_visibility ->
    *[only_common_groups] Die hier aufgeführten Daten sind für die Benutzer:innen sichtbar, mit denen du Gruppen oder Dienststellen teilst. Darüber hinaus können diese Daten nicht eingesehen werden.
    [management_only] Die hier aufgeführten Daten sind ausschließlich für die Leitungen und Verwaltungskräfte deiner Gruppen und Dienststellen sichtbar. Darüber hinaus können diese Daten nicht eingesehen werden.
  }
user-account-profile-visibility-select =
  { $visibility ->
    *[only_common_groups] Sichtbar für Benutzer:innen mit gemeinsamen Dienststellen oder Gruppen
    [management_only] Ausschließlich für deine Leitungen oder Verwaltungskräfte sichtbar
  }
user-settings-email-extra = Gib eine neue gültige E-Mail-Adresse ein. Sobald du die Änderung gespeichert hast, kannst du dich mit der neuen E-Mail-Adresse auf der Plattform anmelden und erhältst alle wichtigen Benachrichtigungen darüber.
user-password-extra = Ändere dein Passwort für diese Plattform.
user-current-password = Aktuelles Passwort
user-current-password-extra = Gib dein aktuelles Passwort ein, um ein neues Passwort zu vergeben.
user-settings-new-password-extra = Das Passwort muss mindestens {$minLength} Zeichen lang sein.

user-settings-current-password-extra = Gib dein aktuelles Passwort ein, um deine E-Mail-Adresse zu ändern.

user-general-languages-extra = Bitte wähle die Sprachen aus, in denen du dir vorstellen kannst die Beratung durchzuführen.

user-personal-denomination-value =
  { $denomination ->
    *[undefined] {""}
    [not_specified] Keine Angabe
    [undenominational] Konfessionslos
    [catholic] Katholisch
    [protestant] Evangelisch
    [other] Andere
  }
user-personal-gender-value =
  { $gender ->
    *[undefined] {""}
    [not_specified] Keine Angabe
    [no_entry] Kein Eintrag
    [diverse] Divers
    [female] Weiblich
    [male] Männlich
  }
user-financial-extra = Deine Konto-Daten sind für andere nicht sichtbar und können nur von deiner Gruppen-Manager:in oder Gruppen-Admin zu administrativen Zwecken eingesehen werden.

user-settings-extra = Deine Account-Details sind für andere nicht sichtbar und können nur von deiner Gruppen-Manager:in oder Gruppen-Admin eingesehen und bearbeitet werden.
user-settings-role-select =
  { $role ->
    *[x_unknown] [{$role}]
    [viewer] Viewer
    [employee_ts_in] Mitarbeiter:in
    [coordinator] Management
    [ts_admin_ts_in] Admin
    [ex_ts_in] Ehemalige:r
  }
user-settings-status-select =
  { $status ->
    *[x_unknown] [{$status}]
    [active] Aktiv
    [inactive] Inaktiv
    [login_lock] Aktiv
  }
user-settings-employment-type-select =
  { $type ->
    *[x_unknown] [{$type}]
    [not_specified] Nicht definiert
    [voluntary] Ehrenamtlich
    [full_time] Hauptamtlich
    [external] Externe:r Mitarbeiter:in
  }

user-settings-permission-only-self = Kann nur von dem:der Benutzer:in selbst bearbeitet werden
user-settings-permission-only-management = Kann nur durch deine Leitung bearbeitet werden
user-settings-status-not-applicable = {" "}(nicht relevant für „{$role}“)

user-ex-dialog-heading = Bitte prüfe genau, ob du die Rolle von „{$display_name}“ zu Ehemalige:r ändern möchtest
user-ex-dialog-message =
  <ul>
    <li>Der Benutzer:innen-Account wird deaktiviert.</li>
    <li>Alle Gruppen-Zugehörigkeiten werden entfernt.</li>
    <li>Erstellte Inhalte, z. B. Dokumentationen, Beiträge und Termine, bleiben erhalten und werden auf die Gruppen-Admin übertragen.</li>
  </ul>
user-ex-dialog-confirm = Ja, Rolle ändern

user-login-lock = Anmelde-gesperrt
user-login-lock-description = Diese:r Benutzer:in ist momentan anmelde-gesperrt
user-login-lock-remove-success = Die Anmeldesperre von „{$display_name}“ wurde aufgehoben.
user-login-lock-legend = Anmeldesperre
user-login-lock-message = Sämtliche Anmeldeversuche für diesen Account werden momentan blockiert. Die Anmeldesperre muss manuell aufgehoben werden.
user-login-lock-reason = Grund:
  { $reason ->
    *[repeatedly_wrong_credentials] Das Passwort wurde {$attempts} mal falsch eingegeben.
  }
user-remove-login-lock = Anmeldesperre aufheben
user-login-lock-dialog-heading = Anmeldesperre
user-login-lock-dialog-message = Bist du sicher, dass du die Anmeldesperre von „{$display_name}“ aufheben möchtest?
user-login-lock-dialog-confirm = Ja, Anmeldesperre aufheben

user-settings-delete-legend = Account löschen
user-settings-delete-unauthorized-message = Das dauerhafte Löschen kann ausschließlich durch deine Gruppen-Manager:in oder Gruppen-Admin erfolgen.
user-settings-delete-authorized-message = Entfernt den Account dauerhaft aus dem System. Alle personenbezogenen Daten werden gelöscht oder anonymisiert. {global-unrecoverable-action}

user-delete = Account löschen
user-delete-dialog-title = Account löschen
user-delete-dialog-message =
  <ul>
    <li>Der Benutzer:innen-Account von „{$display_name}“ wird dauerhaft gelöscht.</li>
    <li>Mit dem Account erstellte Inhalte werden ebenfalls gelöscht.</li>
    <li>Dokumentationen bleiben mit dem Anzeigenamen „{$display_name}“ erhalten.</li>
  </ul>
user-delete-dialog-confirm = Ja, Account löschen
user-delete-success = Der Prozess der Account-Löschung von „{$display_name}“ wurde gestartet.
user-delete-dialog-single-admin-message = Der Löschvorgang kann nicht gestartet werden, da „{$display_name}“ noch Gruppen-Admin oder Gruppen-Manager:in ist. Diese Rolle muss entfernt werden, bevor der Löschvorgang gestartet werden kann. Auf dem Benutzer:innen-Profil findest du alle Mitgliedschaften in der Übersicht.
user-delete-dialog-single-admin-confirm = Zum Profil

user-delete-avatar = Profilbild löschen
user-delete-avatar-dialog-heading = Lösche Profilbild
user-delete-avatar-dialog-message = Bist du sicher, dass du dein Profilbild löschen möchtest?
user-delete-avatar-dialog-confirm = Ja, Profilbild löschen

user-export-download-button = Mitgliederliste exportieren

user-create-cooperation-partner = Benutzer:in Kooperationspartner zugehörig
user-create-skills-choose = Optionen auswählen

user-settings-profile-edit-document-title = Profil bearbeiten
user-settings-profile-edit-page-title = Profil bearbeiten
user-settings-profile-edit-breadcrumb = Profil
user-settings-profile-edit = Profil bearbeiten
user-settings-profile-edit-disabled = Kann nur durch einen Admin bearbeitet werden
